/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsIconBar = {
  init: function($section) {

    //console.log("ICON BAR:", $section[0].id);

    /*const sectionId = $section[0].id;
    console.log(sectionId);
    const iconBarSection = document.querySelector(`#${sectionId}`);
    console.log(iconBarSection);
    carousel = iconBarSection.querySelector('.icon-bar-slider');
    console.log("CAROUSEL:",carousel);*/

    const carousel = document.querySelector('.icon-bar-slider');

    let flkty;

    function manageFlickity() {
      const breakpoint = 800; // Set the breakpoint width
      
      
      if (window.innerWidth < breakpoint) {
        if (!carousel.classList.contains('flickity-enabled')) {
          flkty = new Flickity('.icon-bar-slider', {
            watchCSS: false,
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            wrapAround: false,
            prevNextButtons: false,
            autoPlay: true
          });
        }
      } else {
        if (carousel.classList.contains('flickity-enabled')) {
          if (flkty) {
            flkty.destroy();
            flkty = null;
          }
        }
      }
    }

    manageFlickity();

    window.addEventListener('resize', manageFlickity);

    function debounce(func, wait) {
      let timeout;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, arguments), wait);
      };
    }

    window.addEventListener('resize', debounce(manageFlickity, 250));
  }
}

/******/ })()
;